export default __webpack_public_path__ + "static/media/LogOut.5b38f55c.svg";